import { render, staticRenderFns } from "./ReceptionComponent.vue?vue&type=template&id=12c23d14&scoped=true"
import script from "./ReceptionComponent.vue?vue&type=script&lang=js"
export * from "./ReceptionComponent.vue?vue&type=script&lang=js"
import style0 from "./ReceptionComponent.vue?vue&type=style&index=0&id=12c23d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c23d14",
  null
  
)

export default component.exports